export const APP_ROUTES = Object.freeze({
  home: '/',
  jar: '/jar',
  upcoming: '/upcoming',
  explore: '/explore',
  search: '/explore/search',
  exploreResults: ':prefix/explore/:search/results',
  exploreAllFlyers: '/explore/all',
  exploreNewFlyers: '/explore/new',
  commFreeFlyerboard: '/flyerboard/community-free',
  exploreFlyerboard: '/explore/flyerboard',
  saved: '/saved',
  account: '/account',
  flyerboard: '/flyerboard',
  oldFlyerDetails: '/flyer/:id',
  flyerDetails: '/district/:districtId/flyer/:id',
  orgProfile: '/org/:id/profile',
  accountInformation: '/account/information',
  preference: '/account/preference',
  language: '/account/preference/language',
  notifications: '/account/preference/notifications',
  help: '/account/help',
  login: '/login',
  welcome: '/welcome',
  signUp: '/signup',
  magicLinkSuccess: '/login/magic-link',
  magicLinkExpired: '/login/magic-link/expired',
  updateEmailExpired: '/auth/update-email/expired',
  maps: '/maps',
  embeddedJar: '/embed/jar',
  embeddedFlyerDetails: '/embed/district/:districtId/flyer/:id',
});

export const NON_AUTH_PAGES = [
  APP_ROUTES.login,
  APP_ROUTES.welcome,
  APP_ROUTES.signUp,
  APP_ROUTES.magicLinkExpired,
  APP_ROUTES.magicLinkSuccess,
  APP_ROUTES.updateEmailExpired,
];

export enum FlyerType {
  school = 'school',
  community = 'community',
}

export enum SubscriptionTypeEnum {
  school = 'school',
  community = 'community',
  district = 'district',
}

export enum OrgType {
  school = 'school',
  district = 'district',
}
export enum AidaStatus {
  trial = 'trial',
  on = 'on',
  off = 'off',
}

export const MasonryBreakpointCols = {
  default: 4,
  1100: 3,
  700: 2,
  500: 2,
  341: 1,
};

export const MasonryBreakpointColsList = {
  default: 1,
};

export const MAX_NUMBER_RECENT_SEARCHES = 10;
// export const SAVED_TYPE = Object.freeze({
//   school: 'school',
//   community: 'community',
// });

export const DEFAULT_ERROR_MESSAGE = 'Oops. Something went wrong. Please try again.';

export enum Grades {
  Prekindergarten = 'PK',
  TransitionalKindergarten = 'TK',
  Kindergarten = 'KG',
  Grade1 = '1',
  Grade2 = '2',
  Grade3 = '3',
  Grade4 = '4',
  Grade5 = '5',
  Grade6 = '6',
  Grade7 = '7',
  Grade8 = '8',
  Grade9 = '9',
  Grade10 = '10',
  Grade11 = '11',
  Grade12 = '12',
  ContinuingEducation = 'CE',
}

export const PAGE_SIZE = 10;

export enum VariantEnum {
  success = 'success',
  info = 'info',
  warning = 'warning',
  error = 'error',
}

export enum CategoryId {
  Academics = 'academics',
  Athletics = 'athletics',
  ArtsAndCulture = 'arts_and_culture',
  CollegeAndCareer = 'college_and_career',
  SchedulesAndInformation = 'schedules_and_information',
  HealthAndSafety = 'health_and_safety',
  StudentOrganizations = 'student_organizations',
  FamilySupport = 'family_support',
  VolunteerAndFundraising = 'volunteer_and_fundraising',
  Sports = 'sports',
  RecreationAndDiscovery = 'recreation_and_discovery',
  VolunteerAndLocalService = 'volunteer_and_local_service',
  YouthOrganizations = 'youth_organizations',
}

export type ViewMode = 'grid' | 'list';

export const INFINITE_SCROLL_DESKTOP_MIN_PX = 600;

export const EXPANDED_COMMUNITY_FLYER_DISCLAIMER =
  'Access to this community organization flyer does not imply district sponsorship nor endorsement of this program or event.';

export const EMAIL_REQUIRED_MESSAGE = 'Email Address is required';
export const SCHOOL_NAME_REQUIRED_MESSAGE = 'School Name is required';
export const GRADE_REQUIRED_MESSAGE = 'Grade is required';
export const EMAIL_STRUCTURE_ERROR =
  'Enter a valid email address in the format: example@domain.com';
